// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import classNames from '@ta/common.classnames';
import { Abbreviate } from '@ta/common.text';
import { ActorSocialCounts } from '@ta/social.mentions-pieces';
import { InteractionLogger } from '@ta/tracking.interactions';
import TripAvatars from '@ta/trips.trip-avatars';
import * as Types from '@ta/trips.trip-types';

import AbbreviatedTitle from './AbbreviatedTitle';
import LinkToTrip from './LinkToTrip';
import MemberNameByline from './MemberNameByline';
import Photo from './Photo';

import styles from './ShelfTripSectionInModal.less';

type ExternalProps = {|
  trip: Types.Trip,
|};

type Props = {
  ...ExternalProps,
  isMobile: boolean,
};

const ShelfTripSectionInModal = (props: Props) => {
  const { trip, isMobile } = props;
  const photoLength = isMobile ? 100 : 160;

  if (!trip) {
    return null;
  }

  const ownerId = trip.owner && trip.owner.id;
  const displayName = trip.owner && trip.owner.displayName ? trip.owner.displayName : '';
  const url = trip.owner && trip.owner.route && trip.owner.route.url ? trip.owner.route.url : '';
  const isVerified = trip.owner && trip.owner.isVerified ? trip.owner.isVerified : false;
  const sumAllUgc =
    trip.owner &&
    trip.owner.contributionCounts &&
    trip.owner.contributionCounts.sumAllUgc &&
    trip.owner.contributionCounts.sumAllUgc;

  return (
    <div className={styles.layout}>
      {trip.photo && trip.photo.photoSizes && (
        <LinkToTrip trip={trip}>
          <Photo photo={trip.photo.photoSizes} length={photoLength} placeholder="suitcase-fill" />
        </LinkToTrip>
      )}
      <div className={styles.details}>
        {trip.title ? (
          <LinkToTrip trip={trip} className={classNames('ui_link', styles.title_link)}>
            <AbbreviatedTitle
              title={trip.title}
              className={classNames(styles.title, styles.overflow)}
            />
          </LinkToTrip>
        ) : null}
        {ownerId && (
          <div className={styles.owner_wrap}>
            <InteractionLogger>
              {logInteraction => (
                <TripAvatars
                  trip={trip}
                  onAvatarClick={e => {
                    logInteraction(e, 'userClick', { userId: ownerId });
                  }}
                />
              )}
            </InteractionLogger>
            <div className={styles.social_proof}>
              {displayName && (
                <InteractionLogger>
                  {logInteraction => (
                    <MemberNameByline
                      name={displayName}
                      url={url}
                      isVerified={isVerified}
                      onClick={e => {
                        logInteraction(e, 'userClick', { userId: ownerId });
                      }}
                    />
                  )}
                </InteractionLogger>
              )}
              {sumAllUgc && <ActorSocialCounts contributionCount={sumAllUgc} />}
            </div>
          </div>
        )}
        {!isMobile && trip.description ? (
          <div className={styles.description}>
            <Abbreviate text={trip.description} max={300} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  isMobile: state.meta.device.viewportCategory === 'MOBILE',
}))(ShelfTripSectionInModal);
